import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";

function buildMenu() {
  let children = []

  children.push({ name: 'Accueil', url: '/espace-gestion/accueil', icon: 'icon-home' })
  if (hasRule(rules.ACCESS_ADMIN_EQUIPES)) {
    children.push({ name: 'Gestion Equipes', url: '/espace-gestion/equipes', icon: 'fa fa-group' })
  }

	if (hasRule(rules.ACCESS_RECEPTION_MAIL)) {
    children.push({ name: 'Réception Mail', url: '/espace-gestion/mail', icon: 'icon-envelope' })
  }

  if (hasRule(rules.CAN_MANAGE_CODE_BARRE_DBCO)) {
    children.push({ name: 'Code barre DBCO', url: '/espace-gestion/code-barre-dbco', icon: 'fa fa-barcode' })
  }
  if (hasRule(rules.CAN_MANAGE_CRON_RELANCE_DC)) {
    children.push({ name: 'Relance DC', url: '/espace-gestion/relance-deces', icon: 'fa fa-cog' })
  }
  if (hasRule(rules.CAN_MANAGE_LISTING)) {
    children.push({ name: 'Gestion des Listing', url: '/espace-gestion/listing', icon: 'fa fa-list' })
  }

  if (hasRule(rules.ACCESS_GESTION_DOSSIER)) {
    children.push({ name: 'Gestion Dossiers', url: '/espace-gestion/dossier', icon: 'icon-docs' })
  }

  if (hasRule(rules.CAN_ACCESS_GESTION_BASKET_DOSSIER)) {
    children.push({ name: 'Gestion Corbeilles', url: '/espace-gestion/corbeille/accueil', icon: 'fa fa-clipboard' })
  }

  if (hasRule(rules.CAN_MANAGE_CONSIGNES)) { // hasRule(rules.CAN_CONFIGURE_CONSIGNES)
    let subChildren = [];
    subChildren.push({ name: 'Consignes produit', url: '/espace-gestion/consignes-produit', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Consignes blocage', url: '/espace-gestion/consignes-blocage', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Consignes segment', url: '/espace-gestion/consignes-segment', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Consignes SIREN', url: '/espace-gestion/consignes-siren', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Consignes NIR', url: '/espace-gestion/consignes-nir', icon: 'fa fa-cog' });
    children.push({ name: 'Gestion Consignes', url: '#', icon: 'fa fa-cogs', children: subChildren });
  }

  if (hasRule(rules.CAN_ACCESS_FICHE_SIREN)) {
    children.push({ name: 'Fiches SIREN', url: '/espace-gestion/sirens', icon: 'fa fa-list-alt' });
  }

  if (hasRule(rules.CAN_ACCESS_GROUP_SIREN)) {
    children.push({ name: 'Groupes SIREN', url: '/espace-gestion/groupes-siren', icon: 'fa fa-object-group' });
  }

  if (hasRule(rules.CAN_CHANGE_PREFERENCE_PRESTIJ_MASSE)) {
    children.push({ name: 'MàJ Prestij en masse', url: '/espace-gestion/maj-prestij-siren', icon: 'fa fa-object-group' });
  }

  if (hasRule(rules.CAN_ACCESS_PRODUIT)) {
    let subChildren = [];
    
    subChildren.push({ name: 'Gestion Produit', url: '/espace-gestion/famille-produit', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Gestion Type', url: '/espace-gestion/produit/gestion-type', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Gestion Gamme', url: '/espace-gestion/produit/gestion-gamme', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Gestion Famille', url: '/espace-gestion/produit/gestion-famille', icon: 'fa fa-cog' });
    subChildren.push({ name: 'Gestion Grille', url: '/espace-gestion/produit/gestion-grille', icon: 'fa fa-cog' });
    children.push({ name: 'Produits', url: '#', icon: 'fa fa-braille', children: subChildren });
  }
  // children.push({ name: 'Gestion Produits', url: '/espace-gestion/famille-produit', icon: 'fa fa-braille' });

  if (hasRule(rules.CAN_MANAGE_ACTUALITE)) {
    children.push({ name: 'Gestion Actualités', url: '/espace-gestion/actualite', icon: 'fa fa-newspaper-o' });
  }

  if (hasRule(rules.CAN_ACCESS_EXTRACTIONS)) {
    children.push({ name: 'Extractions', url: '/espace-gestion/extractions', icon: 'fa fa-download' });
  }
  if (hasRule(rules.CAN_ACCESS_ASSURES)){
    children.push({ name: 'Assurés', url: '/espace-gestion/assures', icon: 'fa fa-user' });
  }

  if (hasRule(rules.CAN_ACCESS_IMPORT_RENTES)){
    children.push({ name: 'Histo. chgt rentes', url: '/espace-gestion/chargement-fichier-rentes-inval', icon: 'fa fa-list-alt' });
  }

  if (hasRule(rules.CAN_ACCESS_IMPORT_PRESTIJ)){
    children.push({ name: 'Imports Prest\'IJ', url: '/espace-gestion/chargement-prestij', icon: 'fa fa-upload' });
  }

  if (hasRule(rules.CAN_ACCESS_DECOMPTE_IJ) && hasRule(rules.CAN_ACCESS_DECOMPTE_INVALDC)) {
    let subChildren = [];
    
    subChildren.push({ name: 'Decomptes IJ', url: '/espace-gestion/decomptes-ij', icon: 'fa fa-list-alt' });
    subChildren.push({ name: 'Decomptes Inval/DC', url: '/espace-gestion/decomptes-invaldc', icon: 'fa fa-list-alt' });
    children.push({ name: 'Décomptes', url: '#', icon: 'fa fa-list-alt', children: subChildren });
  } else {
    if (hasRule(rules.CAN_ACCESS_DECOMPTE_IJ)){
      children.push({ name: 'Decomptes IJ', url: '/espace-gestion/decomptes-ij', icon: 'fa fa-list-alt' });
    }

    if (hasRule(rules.CAN_ACCESS_DECOMPTE_INVALDC)){
      children.push({ name: 'Decomptes Inval/DC', url: '/espace-gestion/decomptes-invaldc', icon: 'fa fa-list-alt' });
    }
  }

  if (hasRule(rules.CAN_ACCESS_MODULE_PREV)) {
    let subChildren = [];
    subChildren.push({ name: 'Histo. Intégration', url: '/espace-gestion/module-prev/historique-integration', icon: 'fa fa-list-alt' });
    subChildren.push({ name: 'Imports Retours', url: '/espace-gestion/module-prev/chargements', icon: 'fa fa-upload' });
    if (hasRule(rules.CAN_EXECUTE_OPC_PREV)){
      subChildren.push({ name: 'OCP purge BPIJ', url: '/espace-gestion/module-prev/script-opc-purge-bpij', icon: 'fa fa-upload' });
    }
    children.push({ name: 'Module Prev.', url: '#', icon: 'fa fa-list-alt', children: subChildren });
  }

  if (hasRule(rules.CAN_EXECUTE_OPC_PREV) || hasRule(rules.CAN_EXECUTE_DESAFFECTATION_MASSE_OCP)){
    let subChildren = [];
    subChildren.push({ name: 'Action masse OCP', url: '/espace-gestion/action-masse-ocp', icon: 'fa fa-upload' });
    // if (hasRule(rules.CAN_EXECUTE_DESAFFECTATION_MASSE_OCP)){
    //   subChildren.push({ name: 'Desaffect. en masse', url: '/espace-gestion/desaffectation-masse-ocp', icon: 'fa fa-male' });
    // }
    // children.push({ name: 'Action masse OCP', url: '/espace-gestion/action-masse-ocp', icon: 'fa fa-upload' });
    children.push({ name: 'OCP', url: '#', icon: 'fa fa-hand-grab-o', children: subChildren });
  }

  return children
}
let menu = {
  items: buildMenu()
}
export default menu
